<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg v-if="exceptionMsg" :msg="exceptionMsg" />

    <DeductionsPlanForm
      v-if="!isLoading"
      :deductionsPlanData="deductionsPlanData"
      :submitName="$t('add')"
      v-on:addOrUpdateDeductionsPlan="addOrUpdateDeductionsPlan()"
    />
  </div>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
import { STATUS } from "@/utils/constants";
import DeductionsPlanForm from "@/components/settings/settingsSalary/deductionsPlans/DeductionsPlanForm.vue";
import DeductionsPlan from "@/models/settings/settingsSalary/deductionsPlans/DeductionsPlan";

export default {
  name: "DeductionsPlanAdd",
  components: {
    PreLoader,
    ExceptionWithImg,
    DeductionsPlanForm,
  },
  data() {
    return {
      isLoading: false,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
      deductionsPlanData: new DeductionsPlan(),
    };
  },
  methods: {
    async addOrUpdateDeductionsPlan() {
      this.isLoading = true;
      try {
        let response = await this.deductionsPlanData.addOrUpdateDeductionsPlan(
          this.language,
          this.userAuthorizeToken
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
          this.deductionsPlanData.setInitialValue();
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (e) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
    showMsg(msg = "", isSuccess = false) {
      let variant = isSuccess ? "success" : "danger";
      this.$bvToast.toast(`${msg}`, {
        title: this.$t("alert"),
        variant: variant,
        toaster: "b-toaster-bottom-center",
        autoHideDelay: 5000,
      });
    },
  },
};
</script>

<style scoped lang="scss"></style>
